<template>
  <section :class="{ 'ppv-wrap': cellType === 'band_61' }">
    <component
      :is="isCatalogType ? CatalogLoader : DynamicSectionLoader"
      :catalog-info="catalog"
      :section-info="sectionInfo"
      :multisection-index="index"
    />
  </section>
</template>
<script setup>
  import { computed, defineProps } from 'vue'
  import { getCellType } from '@/common/utils/home/get-cell-type'
  import { getApiType } from '@/common/utils/home/get-api-type'
  import { convertMultiSectionInfo } from '@/common/converter/convert-multi-section-info'
  import { API_TYPE_CATALOG } from '@/common/converter/const'
  import DynamicSectionLoader from '@/components/container/DynamicSectionLoader.vue'
  import CatalogLoader from '@/components/container/CatalogLoader.vue'

  const props = defineProps({
    catalog: {
      type: Object,
      default: null,
    },
    index: {
      type: Number,
      default: 0,
    },
  })

  const cellType = computed(() => getCellType(props.catalog?.elementList) ?? '')
  const apiType = computed(() => getApiType(props.catalog?.elementList) ?? '')
  const isCatalogType = computed(() => apiType.value === API_TYPE_CATALOG)
  const sectionInfo = computed(() => convertMultiSectionInfo(props.catalog))
</script>
